import { apiFetch } from './client'
import { getWorkTenantId } from './workTenant'

/**
 * s59 (decisao D5 de Marcelo, 17/10/2026): empresa com a IA DESLIGADA -- depois do 1o aviso "nao habilitada", os
 * botoes de IA somem da tela. So na tela, por aba (sessionStorage): a API continua sendo quem decide (403), e o
 * sinal vindo da API fica para a s60. A chave e a EMPRESA DE TRABALHO (o administrador da Gente troca de empresa:
 * desligada na LUTEPEL nao pode esconder na Gente).
 */
const PREFIXO = 'strongerh.iaDesligada.'

function chave(): string {
  return PREFIXO + (getWorkTenantId() ?? 'propria')
}

export function isAiDisabledHere(): boolean {
  try {
    return window.sessionStorage.getItem(chave()) === '1'
  } catch {
    return false
  }
}

export function markAiDisabledHere(): void {
  try {
    window.sessionStorage.setItem(chave(), '1')
  } catch {
    // sem storage: o botao continua aparecendo e o aviso continua honesto
  }
}

/**
 * s61 / E4 (decisao de Marcelo 19/10/2026): o SINAL vem da API -- `GET /api/ai/availability` -> `{ enabled }`, a mesma
 * trava das rotas da IA lida sem custo. Com `enabled: false` os botoes nem aparecem (antes, so depois do 1o aviso).
 * A API continua recusando (403) do mesmo jeito: o sinal e conforto de tela, nao seguranca. Se a leitura FALHAR (API
 * antiga, rede), a tela fica como antes (mostra e esconde depois do 1o aviso). A chave inclui a EMPRESA DE TRABALHO.
 */
export function aiAvailabilityKey(): readonly unknown[] {
  return ['ai-availability', getWorkTenantId() ?? 'propria']
}

export async function fetchAiAvailability(): Promise<boolean> {
  const r = await apiFetch<{ enabled?: unknown }>('/api/ai/availability')
  return r.enabled === true
}
